// api/words.ts — (B107) Admin → Words: /api/admin/words/*, the backend's door to the workers' words store (C2.9-1).
import { apiGet, apiPost, apiPut } from "./client.ts";
import type { WordView, WordDetail } from "@/lib/words-admin.ts";

const P = "/admin/words";
type Saved = WordView & { locale: string; changed: boolean; overApproved?: boolean; traceId?: string };
export const wordsApi = {
  list: (locale = "en") => apiGet<{ version: string; locale: string; words: WordView[] }>(`${P}?locale=${locale}`),
  get: (key: string, locale = "en") => apiGet<WordDetail>(`${P}/${encodeURIComponent(key)}?locale=${locale}`),
  save: (key: string, text: string, reason: string) =>
    apiPut<Saved>(`${P}/${encodeURIComponent(key)}`, { text, locale: "en", ...(reason.trim() ? { reason: reason.trim() } : {}) }),
  reset: (key: string, reason: string) =>
    apiPost<Saved>(`${P}/${encodeURIComponent(key)}/reset`, { locale: "en", ...(reason.trim() ? { reason: reason.trim() } : {}) }),
};
